import styled, { css } from 'styled-components';
import { Link as RouterLink, type LinkProps } from 'react-router-dom';

type Props = LinkProps & {
    $underline?: boolean;
};

const styleUnderline = css`
    text-decoration: underline;
`;

const styleWithoutUnderline = css`
    position: relative;
    display: inline-block;
    text-decoration: none;
`;

const baseLinkStyles = css<{ $underline?: boolean }>`
    color: ${props => props.theme.link.color};
    ${props => (props.$underline ? styleUnderline : styleWithoutUnderline)};
    word-break: normal;

    &:hover {
        text-decoration: underline;
    }

    &:active {
        color: ${props => props.theme.root.colors.primary.default};
    }

    &:hover::after {
        width: 100%;
    }
`;

export const StyledRouterLink = styled(RouterLink)<Props>`
    ${baseLinkStyles}
`;

export const StyledNativeLink = styled.a<{ $underline?: boolean }>`
    ${baseLinkStyles}
`;
